import { AxiosPromise } from 'axios';
import { SubmitForm }   from '@/views/events/submodules/events-detail.types';
import { client }       from '@/service/client';

export function submitEvent(submitData: SubmitForm): AxiosPromise {
  return client.post('/setup/events', submitData);
}

export function updateEvent(submitData: SubmitForm, eventUuid: string): AxiosPromise {
  return client.put(`/setup/events/${eventUuid}`, submitData);
}

export function getOneEvent(eventUuid: string): AxiosPromise {
  return client.get(`/setup/events/${eventUuid}`);
}
